import { NbMenuItem } from '@nebular/theme';
import { PendingChangesGuard } from '../@core/service/pending-changes-guard.service';
import { RoleGuardService } from '../@core/service/role-guard.service';
import { ActivityComponent } from './activity/activity.component';
import { AdministrationRegionComponent, AdministrationUserComponent, AdministrationBusinessUnitComponent } from './administration';
import { BusinessComponent } from './business/business.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DevHelperComponent } from './dev-helper/dev-helper.component';
import { BaseProductComponent } from './erp/base-product/base-product.component';
import { CoreComponent } from './erp/core/core.component';
import { DocumentComponent } from './erp/document/document.component';
import { PfspoAvailabilityPageComponent } from './erp/document/pfspo-availability-page/pfspo-availability-page.component';
import { FinishedProductComponent } from './erp/finished-product/finished-product.component';
import { MaterialComponent } from './erp/material/material.component';
import { NavigationComponent } from './erp/navigation/navigation.component';
import { PriceMatrixComponent } from './erp/price-matrix/price-matrix.component';
import { ReportsComponent } from './erp/reports/reports.component';
import { UtilitiesComponent } from './erp/utilities/utilities.component';
import { RouteForbiddenComponent } from './forbidden.component';
import { MyOffersComponent } from './my-offers/my-offers.component';
import { MyProjectsComponent } from './my-projects/my-projects.component';
import { NewsComponent } from './news/news.component';
import { ProjectListComponent, SalesReportComponent, ProjectReportComponent } from './report';
import { ActivityStatisticsComponent } from './report/activity-statistics/activity-statistics.component';
import { OfferListComponent } from './report/offer-list/offer-list.component';
import { TasksComponent } from './tasks/tasks.component';
import { WarehousingComponent } from './warehousing/warehousing.component';
import { OpenordersComponent } from './openorders/openorders.component';
import { OpeninvoicesComponent } from './openinvoices/openinvoices.component';
import { OffersComponent } from './offers/offers.component';
import { OpenprojectsComponent } from './openprojects/openprojects.component';
import { OpenSrsComponent } from './opensrs/opensrs.component';

export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'NRNC',
    icon: 'star-outline',
    link: '/pages/dashboard',
  }, {
    title: 'News',
    icon: 'email-outline',
    link: '/pages/news',
  }, {
    title: 'Activities',
    icon: 'list',
    link: '/pages/activity',
  }, {
    title: 'Tasks',
    icon: 'checkmark',
    link: '/pages/task',
  }, {
    title: 'My Projects',
    icon: 'file-text-outline',
    link: '/pages/myproject',
  }, {
    title: 'My Offers',
    icon: 'shopping-bag-outline',
    link: '/pages/myoffer',
    hidden: false,
  }, {
    title: 'Business',
    icon: 'home-outline',
    link: '/pages/business',
  }, {
    title: 'Reports',
    icon: 'sun-outline',
    hidden: false,
    // link: '/pages/report',
    children: [
      {
        title: 'Offer List',
        link: '/pages/report/offerlist',
        hidden: false,
      },
      {
        title: 'Project List',
        link: '/pages/report/projectlist',
      }, {
        title: 'Sales Report',
        link: '/pages/report/salesreport',
      }, {
        title: 'Project Report',
        link: '/pages/report/projectreport',
      }, {
        title: 'Activity Statistics',
        link: '/pages/report/activitystatistics',
      },
    ],
  }, {
    title: 'NR ERP',
    icon: 'grid-outline',
    hidden: false,
    link: '/pages/erp',
    children: [
      {
        title: 'Navigation',
        link: '/pages/erp/navigation',
      },
      {
        title: 'PFSPO Availability',
        link: '/pages/erp/availability',
      },
      {
        title: 'Core',
        link: '/pages/erp/core',
      },
      {
        title: 'Materials',
        link: '/pages/erp/material',
      },
      {
        title: 'Base Product',
        link: '/pages/erp/base-product',
      },
      {
        title: 'Finished Product',
        link: '/pages/erp/finished-product',
      },
      {
        title: 'Price Matrix NRKA',
        link: '/pages/erp/price-matrix',
        children: [
          {
            title: '- Finished Product',
            link: '/pages/erp/price-matrix/nrka/finished-product',
          },
          {
            title: '- Selling',
            link: '/pages/erp/price-matrix/nrka/selling',
          },
          {
            title: '- Buying',
            link: '/pages/erp/price-matrix/nrka/buying',
          },
          {
            title: '- Comparison',
            link: '/pages/erp/price-matrix/nrka/comparison',
          },
        ],
      },
      {
        title: 'Document NRKA',
        link: '/pages/erp/document/nrka',
      },
      {
        title: 'Offers NRKA & NRKG',
        link: '/pages/erp/offers',
      },
      {
        title: 'Price Matrix NRKG',
        link: '/pages/erp/price-matrix',
        children: [
          {
            title: '- Finished Product',
            link: '/pages/erp/price-matrix/nrkg/finished-product',
          },
          {
            title: '- Selling',
            link: '/pages/erp/price-matrix/nrkg/selling',
          },
          {
            title: '- Buying',
            link: '/pages/erp/price-matrix/nrkg/buying',
          },
          {
            title: '- Comparison',
            link: '/pages/erp/price-matrix/nrkg/comparison',
          },
        ],
      },
      {
        title: 'Document NRKG',
        link: '/pages/erp/document/nrkg',
      },
      {
        title: 'Reports',
        link: '/pages/erp/reports',
      },
      {
        title: 'Utilities',
        link: '/pages/erp/utilities',
        children: [
          {
            title: '- Checklist Editor',
            link: '/pages/erp/utilities/checklist',
          },
          {
            title: '- Changelog Text Editor',
            link: '/pages/erp/utilities/changelog',
          },
          {
            title: '- Tax Hint Editor',
            link: '/pages/erp/utilities/taxHintStore',
          },
          {
            title: '- File Descriptions',
            link: '/pages/erp/utilities/fileDescriptions',
          },
          {
            title: '- Currency Editor',
            link: '/pages/erp/utilities/currency',
          },
          {
            title: '- Payment Editor',
            link: '/pages/erp/utilities/paymentStore',
          },
          {
            title: '- Packing Editor',
            link: '/pages/erp/utilities/packingStore',
          },
          {
            title: '- Business ToP Editor',
            link: '/pages/erp/utilities/businessToP',
          },
          {
            title: '- Display Dates Text',
            link: '/pages/erp/utilities/displayDatesStore',
          },
          {
            title: '- PFSPO Availability',
            link: '/pages/erp/utilities/pfspoAvailability',
          },
          {
            title: '- Project Status',
            link: '/pages/erp/utilities/projectStatus',
          },
          {
            title: '- HS Code Editor',
            link: '/pages/erp/utilities/hsCode',
          },
          {
            title: '- Fiscal Year Editor',
            link: '/pages/erp/utilities/fiscalYear',
          },
          {
            title: '- Static Texts',
            link: '/pages/erp/utilities/staticTexts',
          },
          {
            title: '- Legacy Data Editor',
            link: '/pages/erp/utilities/legacyData',
          },
          {
            title: '- Reports Email',
            link: '/pages/erp/utilities/reportsMail',
          },
          {
            title: '- Reports Email 2',
            link: '/pages/erp/utilities/reportsMail2',
          },
          {
            title: '- Monthly Email HQ',
            link: '/pages/erp/utilities/reportsMailHQ',
          },
        ],
      },
    ],
  }, 
  {
    title: 'PFSPO Availability',
    icon: 'layers-outline',
    link: '/pages/availability',
  },
  {
    title: 'Offers',
    icon: 'layers-outline',
    link: '/pages/offers',
  },
  {
    title: 'Open Orders',
    icon: 'layers-outline',
    link: '/pages/openorders',
  },
  {
    title: 'Open Machinery',
    icon: 'layers-outline',
    link: '/pages/openprojects',
  },
  {
    title: 'Open SRs',
    icon: 'layers-outline',
    link: '/pages/opensrs',
  },
  {
    title: 'Warehousing',
    icon: 'layers-outline',
    link: '/pages/warehousing',
  },
  {
    title: 'Open Invoices',
    icon: 'layers-outline',
    link: '/pages/openinvoices',
  },
  {
    title: 'Administration',
    icon: 'settings-2-outline',
    link: '/pages/administration',
    children: [
      {
        title: 'Users',
        link: '/pages/administration/user',
      }, {
        title: 'Regions',
        link: '/pages/administration/region',
      }, {
        title: 'Business Units',
        link: '/pages/administration/bu',
      // }, {
      //   title: 'Materials',
      //   link: '/pages/administration/material',
      },
    ],
    // hidden: true,
  },
  {
    title: 'Dev Helper',
    icon: 'code-outline',
    link: '/pages/devhelper',
    hidden: true,
  },
  {
    title: 'Logout',
    icon: 'log-out-outline',
    link: '/auth/logout',
  }
  /* {
    title: 'Auth',
    icon: 'nb-locked',
    children: [
      {
        title: 'Login',
        link: '/auth/login',
      },
      {
        title: 'Register',
        link: '/auth/register',
      },
      {
        title: 'Request Password',
        link: '/auth/request-password',
      },
      {
        title: 'Reset Password',
        link: '/auth/reset-password',
      },
    ],
  },*/
];

export const routeSkeleton: any = [{
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['admin', 'dashboard'], antiRoles: ['noCrm'] },
  }, {
    path: 'news',
    component: NewsComponent,
    canActivate: [RoleGuardService],
    data: { antiRoles: ['noCrm'] },
  }, {
    path: 'news/:activity',
    component: NewsComponent,
    canActivate: [RoleGuardService],
    data: { antiRoles: ['noCrm'] },
  }, {
    path: 'business',
    component: BusinessComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['admin','business'], antiRoles: ['noCrm'] },
  }, {
    path: 'business/:mode/:business',
    component: BusinessComponent,
    canActivate: [RoleGuardService],
    data: { antiRoles: ['noCrm'] },
  }, {
    path: 'activity',
    component: ActivityComponent,
    canActivate: [RoleGuardService],
    data: { antiRoles: ['noCrm'] },
  }, {
    path: 'task',
    component: TasksComponent,
    canActivate: [RoleGuardService],
    data: { antiRoles: ['noCrm'] },
  }, {
    path: 'myproject',
    component: MyProjectsComponent,
    canActivate: [RoleGuardService],
    data: { antiRoles: ['noCrm'] },
  }, {
    path: 'myoffer',
    component: MyOffersComponent,
    canActivate: [RoleGuardService],
    data: { antiRoles: ['noCrm'] },
  }, {
    path: 'report/offerlist',
    component: OfferListComponent,
    canActivate: [RoleGuardService],
    data: { antiRoles: ['noCrm'] },
  }, {
    path: 'report/projectlist',
    component: ProjectListComponent,
    canActivate: [RoleGuardService],
    data: { antiRoles: ['noCrm'] },
  }, {
    path: 'report/salesreport',
    component: SalesReportComponent,
    canActivate: [RoleGuardService],
    data: { antiRoles: ['noCrm'] },
  }, {
    path: 'report/projectreport',
    component: ProjectReportComponent,
    canActivate: [RoleGuardService],
    data: { antiRoles: ['noCrm'] },
  }, {
    path: 'report/activitystatistics',
    component: ActivityStatisticsComponent,
    canActivate: [RoleGuardService],
    data: { antiRoles: ['noCrm'] },
  }, {
    path: 'erp',
    canActivate: [RoleGuardService],
    children: [],
    data: { erpRoles: ['admin', 'materials', 'nrka', 'nrkg', 'products', 'reports', 'offers'] },
  }, {
    path: 'erp/navigation',
    component: NavigationComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['admin', 'nrka', 'nrkg', 'products', 'reports'] },
  }, {
    path: 'erp/availability',
    component: PfspoAvailabilityPageComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['admin', 'nrka', 'nrkg'] },
  }, {
    path: 'erp/core',
    component: CoreComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['admin'] },
  }, {
    path: 'erp/material',
    component: MaterialComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['admin', 'materials'] },
  }, {
    path: 'erp/base-product',
    component: BaseProductComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['admin', 'products'] },
  }, {
    path: 'erp/finished-product',
    component: FinishedProductComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['admin', 'products'] },
  }, {
    path: 'erp/price-matrix/:issuer/:mode',
    component: PriceMatrixComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['admin', 'nrka', 'nrkg'] },
  }, {
    path: 'erp/document/:issuer',
    component: DocumentComponent,
    canActivate: [RoleGuardService],
    canDeactivate: [PendingChangesGuard],
    data: { erpRoles: ['admin', 'nrka', 'nrkg'] },
  }, {
    path: 'erp/document/nrka',
    children: [],
    canActivate: [RoleGuardService],
    data: { erpRoles: ['admin', 'nrka'] },
  }, {
    path: 'erp/document/nrkg',
    children: [],
    canActivate: [RoleGuardService],
    data: { erpRoles: ['admin', 'nrkg'] },
  }, {
    path: 'erp/offers',
    component: DocumentComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['offers'] },
  }, {
    path: 'erp/reports',
    component: ReportsComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['admin', 'reports'] },
  }, {
    path: 'erp/utilities/:id',
    component: UtilitiesComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['admin'] },
  }, {
    path: 'availability',
    component: PfspoAvailabilityPageComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['availability'] },
  }, {
    path: 'offers',
    component: OffersComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['offersMenu'] },    
  }, {
    path: 'openorders',
    component: OpenordersComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['openorders'] },    
  }, {
    path: 'opensrs',
    component: OpenSrsComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['openorders'] },    
  }, {
    path: 'openprojects',
    component: OpenprojectsComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['openorders'] },    
  }, {
    path: 'warehousing',
    component: WarehousingComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['warehousing'] },    
  }, {
    path: 'openinvoices',
    component: OpeninvoicesComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['openinvoices'] },    
  },{
    path: 'administration',
    canActivate: [RoleGuardService],
    component: AdministrationRegionComponent,
    data: { erpRoles: ['super', 'admin', 'loginAdmin'] },
  },{
    path: 'administration/region',
    canActivate: [RoleGuardService],
    component: AdministrationRegionComponent,
    data: { erpRoles: ['super', 'admin', 'loginAdmin'] },
  }, {
    path: 'administration/user',
    component: AdministrationUserComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['super', 'loginAdmin'] },
  }, {
    path: 'administration/bu',
    canActivate: [RoleGuardService],
    component: AdministrationBusinessUnitComponent,
    data: { erpRoles: ['super', 'admin'] },
  }, {
    path: 'logout',
    redirectTo: 'news',
  }, {
    path: '403',
    component: RouteForbiddenComponent,
  }, {
    path: 'devhelper',
    component: DevHelperComponent,
    canActivate: [RoleGuardService],
    data: { erpRoles: ['super'] },
  }

  /* {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  }*/,
];
